<app-ng-dynamic-breadcrumb lastLinkColor="#0275D8"></app-ng-dynamic-breadcrumb>
